/*
 * Built with Common Launchpad 2.0.3
 */

// JS
import '~/src/custom/js/index';

// Base SCSS
import '~/src/custom/scss/base.scss';
import '~/src/custom/scss/layout.scss';

// Component JS
import '~/src/custom/js/pagebuilder';
import '~/src/custom/js/components/pagebuilder';
import '~/src/custom/js/components/formbuilder';
import '~/src/custom/js/components/contact-us';
import '~/src/custom/js/utils/formhelper';

// Components SCSS
import '~/src/custom/scss/pagebuilder.scss';
import '~/src/custom/scss/components/hero/hero-category.scss';
import '~/src/custom/scss/components/category-overview/category-description.scss';
import '~/src/custom/scss/layout/footer/_footer-logo-only.scss';
import '~/src/custom/scss/components/related-links/related-links.scss';
import '~/src/custom/scss/components/contact/contact.scss';